import React from 'react';
import TabContext from '@mui/lab/TabContext';
import { ArcTabContextProps } from './types';

const ArcTabContext: React.FC<ArcTabContextProps> = (props) => {
  return <TabContext {...props} />;
};

export default ArcTabContext;